const featuredPropertiesByLifestyle = {
  displayField: 'header',
  name: 'Featured Properties By Lifestyle',
  description: 'Show all properties by lifestyle',
  fields: [
    {
      id: 'header',
      name: 'Header',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'lifestyle',
      name: 'LifeStyle',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    }
  ],
  sys: {
    id: 'featuredPropertiesByLifestyle',
    version: 6,
    updatedAt: '2023-08-02T21:41:23.764Z'
  }
};
export default featuredPropertiesByLifestyle;